<template>
  <div class="auth-container password-recover-container">
    <img class="logo" alt="Feeds.automated logo" src="/app/images/logo.svg" />
    <p>{{ $t('auth.password_remind_label') }}</p>
    <ValidationObserver ref="observer" v-slot="{ invalid }" class="d-flex flex-column">
      <validation-provider class="mb-4" mode="aggressive" rules="email|required" v-slot="{ errors }">
        <input v-model="email" class="form-control" type="text" placeholder="e-mail">
        <span class="validation-error-required" v-if="errors[0] === 'Nieprawidłowy format adresu e-mail'">{{ $t('validations.email_incorrect') }}</span>
      </validation-provider>
      <button type="submit" class="btn btn-orange" :disabled="invalid">{{ $t('auth.password_recover') }}</button>
    </ValidationObserver>
    <router-link :to="{ name: 'auth.login'}">
      <button type="button" class="btn btn-orange btn-large my-3">{{ $t('auth.back_to_login') }}</button>
    </router-link>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import axios from 'axios'

extend('required', {
  ...required
})

extend('email', {
  ...email
})

export default {
  name: 'PasswordRecover',

  data () {
    return {
      email: null
    }
  },

  mounted () {
    window.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) {
        this.sendReset()
      }
    })
  },

  methods: {
    sendReset () {
      if (this.$refs.observer !== undefined) {
        if (this.$refs.observer.flags.valid) {
          axios.post(process.env.VUE_APP_API_ENDPOINT + '/auth/send_reset', {
            email: this.email
          })
            .then((response) => {
              if ((response.status === 201) || (response.status === 200)) {
                this.$router.push({ name: 'auth.password-reset' })
              }
            })
            .catch((error) => {
              if (error.response) {
                const h = this.$createElement
                const message = h(
                  'div',
                  [
                    h('p', this.$t('auth.password_reminder_error_description')),
                    h('p', [
                      h('strong', this.$t('global.error_code')),
                      h('span', error.response.data.statusCode)
                    ]),
                    h('p', [
                      h('strong', this.$t('global.error_status')),
                      h('span', error.response.data.message)
                    ])
                  ]
                )
                this.$bvToast.toast([message], {
                  autoHideDelay: 3000,
                  solid: true,
                  title: this.$t('auth.password_reminder_error'),
                  variant: 'danger'
                })
              }
            })
        }
      }
    }
  },

  components: { ValidationObserver, ValidationProvider }
}
</script>
